import { ProviderAccountStatus } from 'interfaces/linkage'

export const PROVIDER_LOGO_MAP: Record<string, string> = {
  'American Express (Prepaid)': 'american-express',
  'American Express Bank (Personal Savings)': 'american-express',
  'American Express Blue Cash': 'american-express',
  'American Express Business Cards (@ Work)': 'american-express',
  'American Express Cards': 'american-express',
  'American Express Membership Rewards': 'american-express',
  'American Express Serve': 'american-express',

  'Bank of America': 'bank-of-america',
  'Bank of America (HSA & FSA)': 'bank-of-america',
  'Bank of America (Philanthropic Solutions)': 'bank-of-america',
  'Bank of America (Power Rewards)': 'bank-of-america',
  'Bank of America (Prepaid Card)': 'bank-of-america',
  'Bank of America (Retirement)': 'bank-of-america',
  'Bank Of America (Student)': 'bank-of-america',
  'Bank of America (U.S. Trust Clients)': 'bank-of-america',
  'Bank of America (VISA)': 'bank-of-america',
  'Bank of America 401k': 'bank-of-america',
  'Bank of America 401k (Associate Site)': 'bank-of-america',
  'Bank of America CashPro Online': 'bank-of-america',
  'Bank of America Merrill Lynch (Global Card)': 'bank-of-america',
  'Bank of America Merrill Lynch - Account Management': 'bank-of-america',
  'Bank of America Rewards': 'bank-of-america',
  'Bank of American Fork': 'bank-of-america',

  'Capital One': 'capital-one',
  'Capital One (formerly Chevy Chase Bank)': 'capital-one',
  'Capital One - Investments': 'capital-one',
  'Capital One - Mortgage': 'capital-one',
  'Capital One 360': 'capital-one',
  'Capital One 360 (Spark Business)': 'capital-one',
  'Capital One 360 ShareBuilder': 'capital-one',
  'Capital One Bank Private Client (Portfolio Online)': 'capital-one',
  'Capital One Credit Cards': 'capital-one',
  'capital one HRS account': 'capital-one',
  'Capital One Investing': 'capital-one',
  'Capital One Maurices': 'capital-one',
  'Capital One No Hassle Rewards': 'capital-one',

  Chase: 'chase',
  'Chase Cards (formerly FirstUSA)': 'chase',
  'Chase HSA Investments (Broker & Administrator)': 'chase',
  'Chase Insurance Service Center': 'chase',
  'Chase Insurance Service Center (Advisor)': 'chase',
  'Chase J.P.Morgan Commercial Card': 'chase',
  'Chase Pay Card Plus': 'chase',
  'Chase Prepaid Card': 'chase',
  'Chase UCARD (Prepaid)': 'chase',
  'Chase Ultimate Rewards': 'chase',

  'Citi Bank Prepaid': 'citibank',
  'Citi Chairman American Express Card': 'citibank',
  'Citi Commercial Cards': 'citibank',
  'Citi Credit Cards': 'citibank',
  'Citi Easy Deals': 'citibank',
  'Citi Health Card (Citi)': 'citibank',
  'Citi Personal Wealth Management': 'citibank',
  'Citi Platinum Business MasterCard': 'citibank',
  'Citi PremierPass(R) Card(Smith Barney Elite Level)': 'citibank',
  'Citi Private Bank': 'citibank',
  'Citi Private Bank in View': 'citibank',
  'Citi Student Loans': 'citibank',
  CITIBANK: 'citibank',
  Citibank: 'citibank',
  'Citibank (online.citibank.com)': 'citibank',
  'Citibank Health Savings Account': 'citibank',

  'Discover Bank': 'discover',
  'Discover Bank Student Loans': 'discover',
  'Discover benefits Central - 401k': 'discover',
  'Discover Card': 'discover',
  'Discover Financial Services - Personal Loans': 'discover',

  'HSBC Bank': 'hsbc',
  'HSBC Bank (Customer 401k)': 'hsbc',
  'HSBC Bank - Employee 401k (Vanguard)': 'hsbc',
  'HSBC Bank Net Business Banking': 'hsbc',
  'HSBC Evolve- Credit Card': 'hsbc',
  'HSBC Mortgage': 'hsbc',
  'HSBC Mortgage Services': 'hsbc',
  'HSBC Portfolio Online': 'hsbc',
  'HSBC Private Bank': 'hsbc',
  'HSBC Retail Services - Credit Cards': 'hsbc',
  'HSBC Store Branded Credit Card': 'hsbc',

  'PNC (My Benefits Access)': 'pnc',
  'PNC Bank': 'pnc',
  'PNC Bank (Elan) - Credit Cards': 'pnc',
  'PNC Bank (formerly Provident Card (OH))': 'pnc',
  'PNC Bank (Hewitt)': 'pnc',
  'PNC Bank (Small Business)': 'pnc',
  'PNC Bank Small Business (Account View)': 'pnc',
  'PNC Bank(Corporate and Institutional)': 'pnc',
  'PNC CentreSuite': 'pnc',
  'PNC Health Savings Account': 'pnc',
  'PNC Home Equity Online': 'pnc',
  'PNC I-Link': 'pnc',
  'PNC Mortgage': 'pnc',
  'PNC Vested Interest (Participant Login)': 'pnc',

  'TD Ameritrade 401(k) Plan': 'td-bank',
  'TD Ameritrade 529 College Savings Plan': 'td-bank',
  'TD Ameritrade Advisor Client': 'td-bank',
  'TD Ameritrade Corporate Services': 'td-bank',
  'TD Ameritrade Inc.': 'td-bank',
  'TD Ameritrade Institutional-Advisor Services': 'td-bank',
  'TD Auto Finance': 'td-bank',
  'TD Bank': 'td-bank',
  'TD Bank (Business Direct)': 'td-bank',
  'TD Bank - Investments': 'td-bank',
  'TD Bank Commercial Card Direct': 'td-bank',
  'TD Bank(eTreasury)': 'td-bank',
  'TD Banknorth - Mortgage': 'td-bank',
  'TD BankNorth Wealth Management Group': 'td-bank',
  'TD Credit Card Service Online': 'td-bank',
  'TD Wealth Management (Portfolio Online)': 'td-bank',

  'US Bank': 'us-bank',
  'US Bank (SinglePoint)': 'us-bank',
  'US Bank - PIVOT': 'us-bank',
  'US Bank AccelaPay (Prepaid)': 'us-bank',
  'US Bank Convenient Cash (Prepaid)': 'us-bank',

  'Wells Fargo': 'wells-fargo',
  'Wells Fargo (Commercial Electronic Office)': 'wells-fargo',
  'Wells Fargo (Your Retirement Plan)': 'wells-fargo',
  'Wells Fargo - Private Client Services': 'wells-fargo',
  'Wells Fargo - Your BenefitsResources': 'wells-fargo',
  'Wells Fargo 401(k) Online': 'wells-fargo',
  'Wells Fargo Adv. Funds (Inv. Professional)': 'wells-fargo',
  'Wells Fargo Advisors': 'wells-fargo',
  'Wells Fargo and Company 401(k) Plan': 'wells-fargo',
  'Wells Fargo Asset Management': 'wells-fargo',
  'Wells Fargo Business Card Rewards': 'wells-fargo',
  'Wells Fargo Dealer Services': 'wells-fargo',
  'Wells Fargo Deferred Compensation Plan': 'wells-fargo',
  'Wells Fargo Executive Benefits': 'wells-fargo',
  'Wells Fargo Go Far Rewards': 'wells-fargo',
  'Wells Fargo HSA': 'wells-fargo',
  'Wells Fargo Private Bank': 'wells-fargo',
  'Wells Fargo Retirement Plan': 'wells-fargo',
  'Wells Fargo Retirement Services': 'wells-fargo',
  'Wells Fargo Shareowner Services': 'wells-fargo',
  'Wells Fargo Teamworks 401k': 'wells-fargo',
  'Wells Fargo Tuition Rewards': 'wells-fargo',
  'Wells Fargo Wealth Management & Trust': 'wells-fargo',
  'Wells Fargo-YourMortgage': 'wells-fargo',
  'WellsFargo Financial(Visa,Master,Nowline,COD Card)': 'wells-fargo',
}

export const NOT_FINISHED_STATUSES =
  new Set(['verifying', 'gathering', 'retrieving', 'updating', 'mfa_required']) as Set<ProviderAccountStatus>
